import { createReducer } from 'utils';
import { UPDATE_MATCH_MARKETS } from 'constants/actions';

const initialState = {
  matchMarkets: [],
};

export default createReducer(initialState, {
  [UPDATE_MATCH_MARKETS]: (state, payload) => ({
    ...state,
    matchMarkets: payload,
  }),
});

export const getMatchMarkets = state => state.matchMarkets;
